/**
 * Flatten a run-report case's exchanges into an LLM-friendly message array.
 *
 * @param {Object} caseItem - Report case with `exchanges: [{ message, answer }]`.
 * @returns {Array<{ role: 'user'|'assistant', message: string }>}
 */
export const buildReportCaseLlmMessages = (caseItem) => {
  const exchanges = Array.isArray(caseItem?.exchanges) ? caseItem.exchanges : [];
  const messages = [];
  exchanges.forEach((exchange) => {
    const userText = (exchange?.message ?? '').trim();
    if (userText) {
      messages.push({ role: 'user', message: userText });
    }
    const assistantText = (exchange?.answer ?? '').trim();
    if (assistantText) {
      messages.push({ role: 'assistant', message: assistantText });
    }
  });
  return messages;
};

/**
 * @param {Object} caseItem
 * @param {number} [indent=2]
 * @returns {string} Pretty-printed JSON array of `{ role, message }`.
 */
export const buildReportCaseLlmJson = (caseItem, indent = 2) =>
  JSON.stringify(buildReportCaseLlmMessages(caseItem), null, indent);
